import type React from "react";

import {
  Box,
  type BoxProps,
  Stack,
  type StackProps,
  Text,
  Title,
} from "metabase/ui";

import S from "./PeopleSection.module.css";

export function PeopleSection({
  children,
  ...boxProps
}: {
  children?: React.ReactNode;
} & BoxProps) {
  return (
    <Box {...boxProps} style={{backgroundColor: "transparent"}}>
      {children && (
        <Stack gap="lg" style={{backgroundColor: "transparent"}}>
          {children}
        </Stack>
      )}
    </Box>
  );
}

export function PeoplePageWrapper({
  children,
  ...stackProps
}: {
  children: React.ReactNode;
} & StackProps) {
  return (
    <Stack gap="lg" {...stackProps} style={{backgroundColor: "transparent"}} className={S.PageWrapper}>
      {children}
    </Stack>
  );
}
